import React from 'react';
import '../../styles/buttons/radioButton.scss';

export interface RadioButtonProps {
  label: string;
  name: string;
  value: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  name,
  value,
  checked,
  onChange,
  disabled = false,
}) => (
  <label className='radio-button'>
    <input
      type='checkbox' // switched from “radio” to “checkbox”
      className='radio-button__input'
      name={name}
      value={value}
      checked={checked}
      onChange={() => onChange()} // fire toggleDay without the event
      disabled={disabled}
    />
    <span className='radio-button__custom'>
      {checked && (
        <svg
          className='radio-button__icon'
          width='1.6rem'
          height='1.2rem'
          viewBox='0 0 24 24'
          aria-hidden='true'
        >
          <path
            d='M20 6L9 17l-5-5'
            fill='none'
            stroke='#fff'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )}
    </span>
    <span className='radio-button__label'>{label}</span>
  </label>
);

export default RadioButton;
